import { REQUIRED_MESSAGE, requiredString } from '@wyz/utils';
import { z } from 'zod';
import { associatedCriteriaSchema, externalIdSchema } from '~/common/schemas';

export const quoteBrandSchema = z.object({
  publicKey: z.string(),
  name: requiredString,
  segment: z.object({ publicKey: z.string() }),
});

export const quoteBrandTemplateSchema = z.object({
  id: z.string(),
  default: z.boolean(),
  name: requiredString,
  criteria: z.array(associatedCriteriaSchema),
  brands: z
    .array(
      z.object({
        externalId: externalIdSchema,
      }),
    )
    .min(1, REQUIRED_MESSAGE),
  customerScope: z
    .array(
      z.object({
        id: z.string({
          error: (issue) =>
            issue.input === undefined ? REQUIRED_MESSAGE : undefined,
        }),
      }),
    )
    .min(1, REQUIRED_MESSAGE),
});

export const quoteBrandTemplateFormSchema = quoteBrandTemplateSchema
  .omit({
    id: true,
    criteria: true,
    brands: true,
    customerScope: true,
  })
  .extend({
    criteria: z
      .array(
        z.object({
          criterion: z.object({ id: z.string() }),
          values: z.array(requiredString).min(1, {
            error: REQUIRED_MESSAGE,
          }),
        }),
      )
      .min(1, {
        error: REQUIRED_MESSAGE,
      }),
    brands: z.array(quoteBrandSchema).min(1, REQUIRED_MESSAGE),
    customerScope: z.array(z.string()).min(1, REQUIRED_MESSAGE),
  });

export const quoteBrandTemplatePayloadSchema = quoteBrandTemplateSchema.omit({
  id: true,
});
